import { createSelector } from 'reselect';

import getActiveMarket from './getActiveMarket.js';

export default createSelector(getActiveMarket, (activeMarket) => (marketConfig) =>
    marketConfig[activeMarket] || marketConfig.gb || {},
);
